module.exports = __webpack_public_path__ + "img/10.0a3bb164.jpg";